import React from 'react'
import moment from 'moment'
import { Container, Button } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import CloseIcon from '@material-ui/icons/Close';
import { truncateString } from '../../../../services/helpers'
import { useDropZoneState } from '../../../contexts/drop-zone-context'
import { StatusMap } from '../../../../enum/ImportZones'
import {getFromS3} from "../../../../services/backendApi";
import {S3_BUCKETS} from "../../../../backendServices/s3";

const HistoryImports = ({ deleteFile }) => {
    const { filesList } = useDropZoneState()

    const arrangeFilesData = (filesList) => {
        const arrengedData = filesList
            .filter(({ status }) => status === StatusMap.COMPLETED.status)
            .sort((a, b) => (new Date(b.date)) - (new Date(a.date)))
        
        return arrengedData
    }

    return (
        <Container maxWidth="xl" className="white-card list-container">
            <h5 className="title">HISTORY IMPORTS</h5>
            <table className="files-list-table">
                <thead>
                    <tr>
                        <th className="row-date"><h5>Date</h5></th>
                        <th className="row-name"><h5>File Name</h5></th>
                        <th className="row-status"><h5>Status</h5></th>
                        <th className="row-zones-imported"><h5>Zones Imported</h5></th>
                        <th className="row-download"><h5>Download</h5></th>
                        <th className="row-delete-file"></th>
                    </tr>
                </thead>
                <tbody>
                    { 
                        arrangeFilesData(filesList).map(file => {
                            return (<tr key={file.id}>
                                <td>{ moment(file.date).format('MMM DD, YYYY HH:mm') }</td>
                                <td>{ truncateString(file.fileName, 60) }</td>
                                <td style={{ color: StatusMap.COMPLETED.color }}>{ StatusMap.COMPLETED.message }</td>
                                <td>{ file.numberOfZones }</td>
                                <td><Button><a onClick={() => getFromS3(S3_BUCKETS.IMPORT_CSV, file.fileName)} className="pointer-cursor"><ArrowDownwardIcon color="primary"/></a></Button></td>
                                <td ><Button onClick={() => deleteFile(file.id)}><CloseIcon /></Button></td>
                            </tr>)
                        })
                    }
                </tbody>
            </table>
        </Container>
    )
}

export default HistoryImports